export enum AppRoutes {
  HOME = 'home',
  LOGIN = 'login',
  ADD_BANNER = 'add',
  EDIT_BANNER = 'edit',
  ADMIN = 'admin',
}
